var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PushCardList',{attrs:{"isEmbed":_vm.isEmbed,"embedRoomId":_vm.embedRoomId,"env":_vm.env,"webinarId":_vm.webinarId,"scene":_vm.scene}})
}
var staticRenderFns = []

export { render, staticRenderFns }